import { Colors, Font, Spacings } from "@ptml/design-system";
import styled from "styled-components";
import { GradientBorderWrapper } from "./RobotSignal.styles";

export const RobotSignalBannerWrapper = styled(GradientBorderWrapper)`
    display: inline-flex;
    width: auto;
    margin-top: ${Spacings.small};
`;

export const RobotSignalBannerContent = styled.div`
    display: inline-flex;
    align-items: center;
    gap: ${Spacings.xxxsmall};
    padding: ${Spacings.xxxsmall} ${Spacings.small} ${Spacings.xxxsmall} ${Spacings.xxsmall};
    background: ${Colors.White};
    border-radius: inherit;
`;

export const RobotSignalBannerDescription = styled.div`
    display: flex;
    align-items: center;
    gap: ${Spacings.xxxsmall};
    font-size: ${Font.size[14]};
    font-weight: ${Font.weight.bolder};
    color: ${Colors.Orderly.Gunmetal100};
`;
